import { useEffect, useState } from "react";
import { Card } from "../../../components/card/card";
import InputForm from "../../../components/input/input-form";
import SelectComponent from "../../../components/select/select-component";
import { Template } from "../../../components/template/template";
import Button from "../../../components/button/button";
import ProjectUtils from "../../../utils/project-utils";
import { toast } from "react-toastify";
import { useAlarmParametersQuery } from "./components/use-alarm-params-query";
import alarmParametersService from "../../../services/web/alarm-parameters-service";

export default function AlarmParameters() {
    const [delayedMinutes, setDelayedMinutes] = useState(0);
    const [confidenceIndex, setConfidenceIndex] = useState(0);
    const [expireDays, setExpireDays] = useState(0);
    const [sign2Auto, setSign2Auto] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const { data, isLoading } = useAlarmParametersQuery();

    useEffect(() => {
        if (!data) return;

        setDelayedMinutes(data.delayedMinutes);
        setConfidenceIndex(data.confidenceIndex);
        setExpireDays(data.expireDays);
        setSign2Auto(data.sign2Auto);
    }, [data]);

    const validade = () => {
        if (delayedMinutes == null || confidenceIndex == null || expireDays == null || !sign2Auto) return "Preencha todos os campos obrigatórios"

        return null;
    };

    const handleSave = async () => {
        if (isSaving) return;

        const err = validade();
        if (err) { ProjectUtils.swalErrorMessage('Campos obrigatórios', err, "Ok"); return; };

        const body = [
            { "key": "sentry.api.fact.minutestoautomaticsign", "value": String(delayedMinutes) },
            { "key": "sentry.event.minconfidence", "value": String(confidenceIndex) },
            { "key": "user.auto.assign.alarm.plus.days", "value": String(expireDays) },
            { "key": "sentry.alarms.sign2.enabled", "value": String(sign2Auto) },
        ];

        try{
            setIsSaving(true);

            await alarmParametersService.update(body);

            toast.success("Salvo com sucesso");
        } catch (error) {
            console.error(error);
            let message = "Não foi possível salvar.";

            if (error?.response?.status !== 500 && error?.response?.data?.message) {
                message = error.response.data.message;
            }

            ProjectUtils.swalErrorMessage("", message, "Ok");
        } finally {
            setIsSaving(false);
        }
    };

    const sign2AutoOptions = [
        { value: "true", label: "Habilitado" },
        { value: "false", label: "Desabilitado" },
    ];

    return (
        <Template isLoading={isLoading || isSaving}>
            <Template.Header>
                <Template.Title>Parâmetros para assinatura automática de alarmes</Template.Title>
            </Template.Header>
            <Template.Body className="space-y-2">
                <Card>
                    <Card.Body className={"p-[15px] flex flex-col gap-4"}>
                        <div className="mt-2 flex flex-col gap-4 md:flex-row md:items-stretch md:gap-6">
                            <div className="flex flex-col gap-4 w-full md:w-[47%]">
                                <InputForm 
                                    label={"Tempo após a passagem para assinatura automática de alarmes de 1º fase (minutos)"}
                                    type={"number"}
                                    value={delayedMinutes}
                                    min={0}
                                    className={'active'}
                                    onChange={(e) => {
                                        const val = Math.max(0, Number(e.target.value));
                                        setDelayedMinutes(val);
                                    }} 
                                />
                                <InputForm
                                    label={"Índice de confiança máximo para assinatura automática dos alarmes de 1º fase (0-100)"}
                                    type={"number"}
                                    value={confidenceIndex}
                                    min={0}
                                    max={100}
                                    className={'active'}
                                    onChange={(e) => {
                                        const val = Math.max(0, Math.min(100, Number(e.target.value)));
                                        setConfidenceIndex(val);
                                    }}
                                />
                            </div>
                            <div className="hidden md:flex justify-center md:self-stretch">
                                <div className="w-px bg-slate-300 h-full" />
                            </div>
                            <div className="flex flex-col gap-4 w-fill w-[53%]">
                                <InputForm 
                                    label={"Tempo pré-definido para expiração de assinatura automática de alarmes de integração (dias)"}
                                    type={"number"}
                                    value={expireDays}
                                    min={0}
                                    className={'active'}
                                    onChange={(e) => {
                                        const val = Math.max(0, Number(e.target.value));
                                        setExpireDays(val);
                                    }}
                                />
                                <SelectComponent 
                                    label="Segunda fase de alarme"
                                    options={sign2AutoOptions}
                                    type="select"
                                    value={sign2AutoOptions.find(o => o.value === String(sign2Auto)) ?? null}
                                    onChange={(opt) => setSign2Auto(opt?.value ?? "")}
                                />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body className="flex justify-end">
                        <Button

                            onClick={handleSave}
                            target="primary"
                            disabled={isSaving || isLoading}
                         actionFeedbackType='save'>
                            Salvar
                        </Button>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}